<template>
  <v-snackbar
    v-if="content"
    v-model="isSnackbarVisible"
    top
    text
    :light="$vuetify.theme.dark"
    :color="status"
    :timeout="timeout"
  >
    <div v-for="(line, index) in content.split('///')" :key="`line-${index}`">
      <span>{{ line }}</span>
    </div>
    <template v-slot:action="{ attrs }">
      <v-btn
        icon
        :color="status"
        v-bind="attrs"
        @click="isSnackbarVisible = false"
      >
        <v-icon>{{ icons.mdiClose }}</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mdiClose } from '@mdi/js'
import {
  ref,
  onMounted,
  computed,
  inject,
} from '@vue/composition-api'

export default {
  setup() {
    const store = inject('store')
    const isSnackbarVisible = ref(false)
    const content = computed(() => store.state.snackbar.content)
    const status = computed(() => store.state.snackbar.status)
    const timeout = computed(() => store.state.snackbar.timeout)

    onMounted(() => {
      store.subscribe(mutation => {
        if (mutation.type === 'SHOW_SNACKBAR') isSnackbarVisible.value = true
      })
    })

    return {
      isSnackbarVisible,
      content,
      status,
      timeout,

      icons: {
        mdiClose,
      },
    }
  },
}
</script>
